import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "menu", "search", "characterList"]

  connect() {
    this.boundClose = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    const menu = this.menuTarget
    const isHidden = menu.classList.contains("hidden")

    if (isHidden) {
      menu.classList.remove("hidden")
      document.addEventListener("click", this.boundClose)
      this.searchTarget.focus()
    } else {
      this.closeMenu()
    }
  }

  closeOnOutsideClick(event) {
    if (!this.dropdownTarget.contains(event.target)) {
      this.closeMenu()
    }
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundClose)
  }

  filterCharacters(event) {
    const query = event.target.value.toLowerCase()
    const buttons = this.characterListTarget.querySelectorAll(".character-option")
    buttons.forEach(btn => {
      const name = btn.dataset.characterName?.toLowerCase() || ""
      btn.closest("button") ? null : null
      btn.style.display = name.includes(query) ? "" : "none"
    })
  }

  selectCharacter(event) {
    const characterId = event.currentTarget.dataset.characterId
    document.getElementById("character-filter-input").value = characterId
    document.getElementById("character-filter-form").submit()
  }
}
